module.exports = __webpack_public_path__ + "static/media/SVN.8ed0c376.jpg";